import { CSSProperties, ReactNode, createElement } from "react";
import { useTranslation } from "react-i18next";

// Type/Interface to avoid unwanted tags such as 'divs' e.g.
type TagVariants =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "p"
  | "span"
  | "label";

type TypographyProps = {
  tag: TagVariants;
  children: ReactNode | string;
  type: keyof typeof style;
  color?: keyof typeof colors;
  addClass?: string | null;
  id?: string;
};

const style = {
  smallest: "text-[10px] opacity-75",
  list: "",
  label: "text-sm",
  default: "text-base",
  semibold: "font-semibold",
  bold: "text-sm font-bold",
  accent: "text-blue-700",
  subtitle: "text-accentRed text-xl font-semibold",
  title: "text-accentRed text-xl font-bold",
  header: "font-bold lg:text-4xl leading-none md:text-2xl",
  text2xl: "lg:text-2xl md:text-2xl sm:text-base",
  giant: "lg:text-7xl md:text-6xl text-5xl font-bold",
};

export const colors = {
  default: "text-dafault",
  secondary: "text-secondary",
  white: "text-white",
  noColor: "",
  accentBlueDark: "text-accentBlueDark",
  accentRed: "text-accentRed",
  faded: "text-gray-600",
};

const Typography = ({
  tag,
  id,
  children,
  type,
  color = "default",
  addClass = "",
}: TypographyProps & CSSProperties) => {
  const { t } = useTranslation();

  return createElement(
    tag,
    { id: id, className: `${addClass} ${style[type]} ${colors[color]} font-sans` },
    typeof children === "string" ? t(children) : children
  );
};

export default Typography;
